var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaqLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "173.7px",
    height: "93.3px",
    viewBox: "0 0 173.7 93.3",
    style: {
      enableBackground: "new 0 0 173.7 93.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M54.2,74v-8.7c0-0.4,0.2-0.6,0.6-0.6h3.5c2.4,0,3.8,1.2,3.8,3.2c0,2-1.3,3.2-3.8,3.2h-2.1v3 c0,0.4-0.2,0.6-0.6,0.6h-0.9C54.5,74.6,54.2,74.4,54.2,74z M58.5,69.4c0.9,0,1.6-0.5,1.6-1.5c0-1-0.6-1.5-1.6-1.5h-2.2v3H58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M71.6,74.6h-1.2c-0.4,0-0.5-0.2-0.6-0.6l-0.5-1.3h-4.5L64.1,74c-0.2,0.4-0.2,0.6-0.6,0.6h-1.1 c-0.4,0-0.6-0.2-0.4-0.6l4.2-8.9c0.2-0.3,0.4-0.5,0.7-0.5h0.1c0.4,0,0.6,0.2,0.7,0.5L72,74C72.2,74.4,72,74.6,71.6,74.6z  M68.6,71.3L67,67.4l-1.7,3.9H68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M81.2,74c0.2,0.4,0,0.6-0.4,0.6h-1.1c-0.4,0-0.5-0.2-0.7-0.6l-1.8-3.3h-1.7V74 c0,0.4-0.2,0.6-0.6,0.6h-0.9c-0.4,0-0.6-0.2-0.6-0.6v-8.7c0-0.4,0.2-0.6,0.6-0.6h3.5c2.5,0,3.8,1.2,3.8,3.1c0,1.4-0.8,2.3-2.1,2.8 L81.2,74z M75.5,69.3h2.2c0.9,0,1.6-0.6,1.6-1.4c0-0.9-0.6-1.5-1.6-1.5h-2.2V69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M85.2,74v-7.6h-2.6c-0.4,0-0.6-0.2-0.6-0.6v-0.5c0-0.4,0.2-0.6,0.6-0.6h7.2c0.4,0,0.6,0.2,0.6,0.6 v0.5c0,0.4-0.2,0.6-0.6,0.6h-2.6V74c0,0.4-0.2,0.6-0.6,0.6h-0.9C85.4,74.6,85.2,74.4,85.2,74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M100.5,65.3V74c0,0.4-0.3,0.6-0.7,0.6h-0.1c-0.4,0-0.6-0.2-0.9-0.5l-4.9-5.9V74 c0,0.4-0.2,0.6-0.6,0.6h-0.9c-0.4,0-0.6-0.2-0.6-0.6v-8.8c0-0.5,0.3-0.6,0.7-0.6h0.1c0.4,0,0.6,0.2,0.9,0.6l4.9,5.9v-5.7 c0-0.4,0.2-0.6,0.6-0.6h0.9C100.2,64.7,100.5,64.9,100.5,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M102.8,74v-8.7c0-0.4,0.2-0.6,0.6-0.6h5.9c0.4,0,0.6,0.2,0.6,0.6v0.5c0,0.4-0.2,0.6-0.6,0.6h-4.4 v2.4h3.3c0.4,0,0.6,0.2,0.6,0.6v0.5c0,0.4-0.2,0.6-0.6,0.6h-3.3v2.5h4.4c0.4,0,0.6,0.2,0.6,0.6V74c0,0.4-0.2,0.6-0.6,0.6h-5.9 C103.1,74.6,102.8,74.4,102.8,74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M119.5,74c0.2,0.4,0,0.6-0.4,0.6H118c-0.4,0-0.5-0.2-0.7-0.6l-1.8-3.3h-1.7V74 c0,0.4-0.2,0.6-0.6,0.6h-0.9c-0.4,0-0.6-0.2-0.6-0.6v-8.7c0-0.4,0.2-0.6,0.6-0.6h3.5c2.5,0,3.8,1.2,3.8,3.1c0,1.4-0.8,2.3-2.1,2.8 L119.5,74z M113.8,69.3h2.2c0.9,0,1.6-0.6,1.6-1.4c0-0.9-0.6-1.5-1.6-1.5h-2.2V69.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 173.7,
    height: 93.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140734644903718024250000004222815865786101939_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#FFFFFF"
    },
    d: "M117,36.7 c-0.6,0-0.7,0-0.8,0.5l-0.9,2.8c-0.1,0.5-0.2,0.7-0.2,0.9c0,0.1,0.2,0.3,0.9,0.4l0.7,0.1c0.1,0.2,0.2,0.7,0,0.9 c-0.9,0-1.8,0-2.9-0.1c-0.8,0-1.4,0.1-2.5,0.1c-0.3-0.1-0.2-0.7-0.1-0.9l0.7-0.1c0.6-0.1,1.1-0.3,1.5-1.2c0.4-1,0.9-2.1,1.5-3.9 l2.2-6c0.6-1.5,1-2.4,1-3.1c1.2-0.3,2.1-1.5,2.1-1.5c0.3,0,0.5,0.1,0.6,0.5c0.2,0.7,0.5,1.6,1.1,3.3l3.3,9.6c0.5,1.5,0.7,2,1.6,2.2 l0.9,0.1c0.1,0.1,0.2,0.7,0,0.9c-1.2,0-2.5-0.1-3.8-0.1c-1.2,0-2.2,0-3.3,0.1c-0.3-0.1-0.3-0.7,0-0.9l0.8-0.1 c0.6-0.1,0.7-0.3,0.7-0.4c0-0.2-0.2-0.8-0.5-1.7l-0.7-2.1c-0.1-0.4-0.3-0.4-1.2-0.4H117z M119.6,35.5c0.6,0,0.7-0.1,0.5-0.7l-0.6-2 c-0.3-1-0.7-2-0.9-2.6c-0.2,0.5-0.6,1.6-1,2.7l-0.6,1.8c-0.2,0.7-0.1,0.7,0.5,0.7H119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#FFFFFF"
    },
    d: "M144.2,39.5 c0,1,0,1.5,0.5,1.6c0.1,0.1,0.1,0.5-0.1,0.6c-0.4,0.1-1,0.1-1.7,0.4c-0.9,0.3-3,0.6-4.3,0.6c-1.7,0-3.1-0.2-4.8-0.9 c-2.9-1.1-4.8-3.9-4.8-7.4c0-3,1.4-5.7,4.3-7.4c1.7-0.9,3.6-1.3,5.7-1.3c2.7,0,4.1,0.6,4.8,0.6c0.1,0.7,0.1,2.4,0.3,3.9 c-0.1,0.3-0.8,0.3-0.9,0c-0.8-2.3-2.3-3.4-4.6-3.4c-3.9,0-5.8,3.2-5.8,7.1c0,3.5,1.2,5.6,2.8,6.6c1.2,0.8,2.4,0.9,3.3,0.9 c1.4,0,1.7-0.3,1.7-1.9v-1.5c0-1.3-0.1-1.5-1.3-1.6l-1.1-0.1c-0.3-0.1-0.3-0.7,0-0.9c1.7,0,2.9,0.1,4.1,0.1c1.2,0,2.4,0,3.2-0.1 c0.2,0.1,0.2,0.7,0,0.9l-0.6,0.1c-0.7,0.1-0.9,0.4-0.9,1.7V39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#FFFFFF"
    },
    d: "M95.9,23.5 c0-0.4,0.1-0.5,0.5-0.6c4,3.1,10.7,9.4,10.7,16.6c0,7.1-6.7,13.5-10.7,16.6c-0.3,0-0.5-0.2-0.5-0.6c3.2-4,7.8-9.1,7.8-16 C103.7,32.6,99.1,27.5,95.9,23.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#A19F96"
    },
    d: "M97.5,44.6 c0,0.4-0.1,0.5-0.5,0.6c-4-3.1-10.7-9.4-10.7-16.6S93,15.2,97,12.1c0.3,0,0.5,0.2,0.5,0.6c-3.2,4-7.8,9.1-7.8,16 C89.6,35.5,94.2,40.7,97.5,44.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#FBB800"
    },
    d: "M96.7,31.5 c1.5,0,2.7,1.3,2.7,2.9c0,1.6-1.2,2.9-2.7,2.9c-1.5,0-2.7-1.3-2.7-2.9C94,32.8,95.2,31.5,96.7,31.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#FFFFFF"
    },
    d: "M42.4,26.3 c0,0.4,0.1,2.4,0.3,3.8c-0.1,0.3-0.8,0.4-0.9,0.2c-0.7-2.3-2.2-3.5-4.6-3.5c-2.7,0-5.7,2.3-5.7,7.2c0,4.9,2.8,7.5,5.8,7.5 c3,0,4.4-2.1,5-3.8c0.2-0.2,0.8-0.1,0.9,0.2c-0.2,1.8-0.6,3.3-0.9,3.9c-1.3,0.4-3.1,0.9-5,0.9c-2.4,0-4.9-0.6-6.6-1.9 c-1.8-1.4-3.1-3.4-3.1-6.4c0-3,1.3-5.1,3-6.5c1.7-1.5,4.3-2.2,6.8-2.2C39.9,25.6,41.7,26.2,42.4,26.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#FFFFFF"
    },
    d: "M51.9,36.7 c-0.6,0-0.7,0-0.8,0.5L50.2,40c-0.1,0.5-0.2,0.7-0.2,0.9c0,0.1,0.2,0.3,0.9,0.4l0.7,0.1c0.1,0.2,0.2,0.7,0,0.9 c-0.9,0-1.8,0-2.9-0.1c-0.8,0-1.4,0.1-2.5,0.1c-0.3-0.1-0.2-0.7-0.1-0.9l0.7-0.1c0.6-0.1,1.1-0.3,1.5-1.2c0.4-1,0.9-2.2,1.5-3.9 l2.2-6c0.6-1.5,1-2.4,1-3.1c1.2-0.3,2.1-1.5,2.1-1.5c0.3,0,0.5,0.1,0.6,0.5c0.2,0.7,0.5,1.6,1.1,3.4l3.3,9.6c0.5,1.5,0.7,2,1.6,2.2 l0.9,0.1c0.1,0.1,0.2,0.7,0,0.9c-1.2,0-2.5-0.1-3.8-0.1c-1.2,0-2.2,0-3.3,0.1c-0.3-0.1-0.3-0.7,0-0.9l0.8-0.1 c0.6-0.1,0.7-0.3,0.7-0.4c0-0.2-0.2-0.8-0.5-1.7l-0.7-2.1c-0.1-0.4-0.3-0.4-1.2-0.4H51.9z M54.6,35.4c0.6,0,0.7-0.1,0.5-0.7l-0.6-2 c-0.3-1.1-0.7-2.1-0.9-2.6c-0.2,0.5-0.6,1.6-1,2.7l-0.6,1.8c-0.2,0.7-0.1,0.7,0.5,0.7H54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "#FFFFFF"
    },
    d: "M82.3,43.3 c0,0-1.4,0.7-4-2.3c2.1-1.5,3.3-3.9,3.3-7c0-5-3.5-8.4-8.6-8.4c-5.1,0-8.8,3.8-8.8,8.6c0,5.1,3.6,8.4,8.5,8.4 c1.3,0,2.4-0.2,3.5-0.5c2.7,3.7,6.3,2.2,6.3,2.2C82.7,43.9,82.5,43.6,82.3,43.3 M68.1,33.7c0-4.1,1.6-6.9,4.6-6.9 c3,0,4.9,3.4,4.9,7.6c0,1.9-0.3,3.6-0.9,4.8c-3-3.4-5.5-1.8-5.5-1.8c0,0.2-0.1,0.4,0.2,0.7c0,0,1.5-0.7,3.9,2.7 c-0.6,0.4-1.3,0.6-2.2,0.6C69.2,41.5,68.1,36.7,68.1,33.7"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 10
    },
    x1: 156.7,
    y1: 53.1,
    x2: 105,
    y2: 53.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000140734644903718024250000004222815865786101939_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 10
    },
    x1: 93.3,
    y1: 53.1,
    x2: 16.6,
    y2: 53.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaqLight);
export default __webpack_public_path__ + "static/media/CAQ-light.cece0b0baea0a3b9af462a4b6e6aecfc.svg";
export { ForwardRef as ReactComponent };